/* Selector de moneda LATAM — conversión SOLO VISUAL de los precios.
   El cobro siempre se procesa en COP; por eso cada precio convertido lleva
   "≈" y al elegir moneda aparece un aviso. Tasas: /apps/tcg/tasas (app). */
(function () {
  'use strict';

  var slot = document.querySelector('[data-tcg-moneda-slot]');
  if (!slot) return;

  /* Sin emojis de bandera: Windows no los renderiza y ensucian el select. */
  var MONEDAS = [
    { c: 'COP', n: 'COP · Colombia' },
    { c: 'USD', n: 'USD · Internacional' },
    { c: 'MXN', n: 'MXN · México' },
    { c: 'PEN', n: 'PEN · Perú' },
    { c: 'CLP', n: 'CLP · Chile' },
    { c: 'ARS', n: 'ARS · Argentina' },
    { c: 'BRL', n: 'BRL · Brasil' },
    { c: 'UYU', n: 'UYU · Uruguay' },
    { c: 'PYG', n: 'PYG · Paraguay' },
    { c: 'BOB', n: 'BOB · Bolivia' },
    { c: 'CRC', n: 'CRC · Costa Rica' },
    { c: 'GTQ', n: 'GTQ · Guatemala' },
    { c: 'DOP', n: 'DOP · R. Dominicana' },
    { c: 'HNL', n: 'HNL · Honduras' },
    { c: 'NIO', n: 'NIO · Nicaragua' }
  ];
  var SIN_DECIMALES = { COP: 1, CLP: 1, PYG: 1 };
  var SEL = '.price-item, .totals__total-value, .cart-item__price-wrapper .price, .product__inventory ~ .price';
  /* Cubre "$ 12.500" y "$12.500 COP" (formato money_with_currency de Crave). */
  var RE_PRECIO = /\$\s?\d[\d.,]*(?:\s*COP\b)?/g;

  var moneda = 'COP';
  try { moneda = localStorage.getItem('tcgMoneda') || 'COP'; } catch (e) {}
  var tasas = null;
  var timer = null;

  /* ---- UI ---- */
  var select = document.createElement('select');
  select.setAttribute('aria-label', 'Moneda de referencia');
  select.innerHTML = MONEDAS.map(function (m) {
    return '<option value="' + m.c + '">' + m.n + '</option>';
  }).join('');
  select.value = MONEDAS.some(function (m) { return m.c === moneda; }) ? moneda : 'COP';
  slot.appendChild(select);

  /* En móvil la elegida se rotula solo con el código ("COP"): con el país
     al lado el selector se comía el ancho del logo. La lista abierta sigue
     mostrando el país de cada moneda. Va con field-sizing en tcg-header.css. */
  var movil = window.matchMedia('(max-width: 749px)');
  function rotula() {
    [].forEach.call(select.options, function (o, i) {
      o.textContent = movil.matches && o.selected ? MONEDAS[i].c : MONEDAS[i].n;
    });
  }
  rotula();
  if (movil.addEventListener) movil.addEventListener('change', rotula);

  select.addEventListener('change', function () {
    rotula();
    moneda = select.value;
    try { localStorage.setItem('tcgMoneda', moneda); } catch (e) {}
    if (moneda === 'COP') { revierte(); return; }
    conTasas(function () { convierte(); aviso(); });
  });

  function aviso() {
    var prev = document.querySelector('.tcg-moneda-aviso');
    if (prev) prev.remove();
    var el = document.createElement('div');
    el.className = 'tcg-moneda-aviso';
    el.textContent = 'Precios aproximados en ' + moneda + '. El pago se procesa en pesos colombianos (COP).';
    document.body.appendChild(el);
    setTimeout(function () { el.classList.add('is-out'); }, 5200);
    setTimeout(function () { el.remove(); }, 5800);
  }

  /* ---- tasas ---- */
  function conTasas(fn) {
    if (tasas) return fn();
    try {
      var c = JSON.parse(sessionStorage.getItem('tcgTasas'));
      if (c && c.tasas && Date.now() - c.t < 6 * 3600e3) { tasas = c.tasas; return fn(); }
    } catch (e) {}
    fetch('/apps/tcg/tasas', { headers: { Accept: 'application/json' } })
      .then(function (r) { var ct = r.headers.get('content-type') || ''; if (!r.ok || ct.indexOf('json') === -1) throw 0; return r.json(); })
      .then(function (j) {
        if (!j || !j.tasas || !j.tasas.USD) throw 0;
        tasas = j.tasas;
        try { sessionStorage.setItem('tcgTasas', JSON.stringify({ t: Date.now(), tasas: tasas })); } catch (e) {}
        fn();
      })
      .catch(function () { select.value = 'COP'; moneda = 'COP'; });
  }

  /* ---- conversión ---- */
  function parsea(txt) {
    var s = txt.replace(/[^0-9.,]/g, '');
    if (!s) return null;
    var n = parseFloat(s.replace(/\./g, '').replace(',', '.'));
    return isFinite(n) ? n : null;
  }
  function formatea(v) {
    var dec = SIN_DECIMALES[moneda] ? 0 : 2;
    try {
      return new Intl.NumberFormat('es', {
        style: 'currency', currency: moneda, currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: dec
      }).format(v);
    } catch (e) {
      try {
        return new Intl.NumberFormat('es', { style: 'currency', currency: moneda, maximumFractionDigits: dec }).format(v);
      } catch (e2) { return moneda + ' ' + v.toFixed(dec); }
    }
  }
  function convierte() {
    if (!tasas || moneda === 'COP') return;
    var tasa = tasas[moneda];
    if (!tasa) return;
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector && el.querySelector(SEL)) continue; /* evita anidados dobles */
      if (!el.dataset.tcgCop) {
        if (!RE_PRECIO.test(el.textContent)) continue;
        el.dataset.tcgCop = el.textContent;
      }
      var orig = el.dataset.tcgCop;
      var out = orig.replace(RE_PRECIO, function (m) {
        var n = parsea(m);
        return n == null ? m : '≈' + formatea(n * tasa);
      });
      if (el.textContent !== out) el.textContent = out;
    }
  }
  function revierte() {
    var els = document.querySelectorAll('[data-tcg-cop]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = els[i].dataset.tcgCop;
      delete els[i].dataset.tcgCop;
    }
  }

  /* precios que llegan después (drawer del carrito, quick view, fetchs) */
  new MutationObserver(function () {
    if (moneda === 'COP' || !tasas) return;
    clearTimeout(timer);
    timer = setTimeout(convierte, 250);
  }).observe(document.body, { childList: true, subtree: true });

  if (moneda !== 'COP') conTasas(convierte);

  /* estilos del aviso */
  var st = document.createElement('style');
  st.textContent = '.tcg-moneda-aviso{position:fixed;left:50%;bottom:18px;transform:translateX(-50%);z-index:120;' +
    'max-width:92vw;padding:.65rem 1.1rem;border-radius:999px;font-size:.8rem;font-weight:600;text-align:center;' +
    'color:#f3eee4;background:rgba(20,21,26,.95);border:1px solid rgba(226,180,92,.5);box-shadow:0 10px 30px -10px rgba(0,0,0,.6);' +
    'transition:opacity .5s ease}.tcg-moneda-aviso.is-out{opacity:0}';
  document.head.appendChild(st);
})();
